module.exports = __webpack_public_path__ + "img/icon_demonstration_blue.392485af.svg";